class CartSuggestions extends HTMLElement {
  connectedCallback() {
    if (this.handleSubmit) return;
    this.handleSubmit = this.addSuggestion.bind(this);
    this.addEventListener('submit', this.handleSubmit);
  }

  async addSuggestion(event) {
    const form = event.target.closest('form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (this.busy) return;
    this.busy = true;
    button.disabled = true;
    const status = this.querySelector('[role="status"]');
    status.textContent = '';
    status.removeAttribute('data-error');
    const mainCart = document.getElementById('main-cart-items');
    const cartSection = mainCart?.dataset.id;
    const sections = ['cart-notification-content', 'cart-notification-crosssell-products', 'cart-icon-bubble'];
    if (cartSection) sections.push(cartSection);
    const body = new FormData(form);
    body.set('sections', sections.join(','));
    body.set('sections_url', window.location.pathname);
    let added = false;
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
      }
      added = true;
      // A successful add must never be retried if section rendering fails.
      const drawer = document.querySelector('cart-notification');
      if (drawer && typeof drawer.updateContent === 'function') drawer.updateContent(result.sections);
      if (cartSection) {
        const html = result.sections?.[cartSection];
        if (!html) throw new Error('Cart section was unavailable');
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        for (const selector of ['.checkout-content-left', '#main-cart-footer']) {
          const target = mainCart.querySelector(selector);
          const source = parsed.querySelector(selector);
          if (target && source) target.innerHTML = source.innerHTML;
        }
      }
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (!cartResponse.ok) throw new Error('Cart totals were unavailable');
      const cart = await cartResponse.json();
      window.cartCount?.(cart);
      window.initFreeshippingGoal?.(cart);
      window.setCartCountTab?.();
      const replacement = cartSection
        ? mainCart.querySelector('cart-suggestions')
        : document.querySelector('#cart-notification-content cart-suggestions');
      replacement?.querySelector('button, a')?.focus();
    } catch (error) {
      if (added) {
        window.location.assign(window.Shopify.routes.root + 'cart');
        return;
      }
      status.textContent = error.message || this.dataset.error;
      status.setAttribute('data-error', '');
      status.focus();
    } finally {
      this.busy = false;
      button.disabled = false;
    }
  }
}
if (!customElements.get('cart-suggestions')) customElements.define('cart-suggestions', CartSuggestions);
